<template>
  <div class="row">
    <div class="col-10 col-xl-12">
      <div class="edit-title-name">
        <i :class="icon"></i>
        <h1>{{title}}</h1>
      </div>
    </div>
    <div class="col-2 m-show-xl rm-p-l">
      <div class="dropdown mobile-menu-dropdown">
        <a href="javascript:" class="mobile-menu-link" :id="'m-medium-'+id" data-toggle="dropdown" aria-haspopup="true"
           aria-expanded="false">
          <i class="fal fa-bars"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-right" :aria-labelledby="'m-medium-'+id">
          <slot name="menu"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      icon: String,
      title: String,
      id: String
    },
  }
</script>